import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

/* Values match fundNames.aif_category in the API (1 / 2 / 3). */
export const AifCategories = [
    { id: 1, name: "Category I" },
    { id: 2, name: "Category II" },
    { id: 3, name: "Category III" },
];

/**
 * The `AifCategoryFilter` function is a React component that renders a filter for selecting AIF
 * category options, and updates the selected options based on user input.
 * @returns a JSX element.
 */
function AifCategoryFilter({ AifCategoryOptions, setAifCategoryOptions, customPathname, label = "AIF Category", isPopupOpen, setIsPopupOpen }) {

    const { refineSearchFilters } = useContext(PeFilterContext);

    // Use internal state only if props are not provided (for backward compatibility)
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const categoryIds = refineSearchFilters[customPathname]?.aifCategory?.map(value => value.id) ?? [];
        setAifCategoryOptions(AifCategories.map(category => ({ ...category, isChecked: categoryIds.includes(category.id) })))
    }, [customPathname, refineSearchFilters, setAifCategoryOptions])

    /* The `handleAifCategoryChange` function is triggered when the user selects or deselects an AIF
    category option. It receives an event object `e` as a parameter. */
    const handleAifCategoryChange = ((e) => {
        const { name, checked, id, filteredIds } = e.target;

        if (name === "allSelect") {
            setAifCategoryOptions(AifCategoryOptions.map((category) => ({ ...category, isChecked: checked })));
        } else if (name === "filteredSelect" && filteredIds) {
            setAifCategoryOptions(AifCategoryOptions.map((category) =>
                filteredIds.includes(category.id) ? { ...category, isChecked: checked } : category
            ));
        } else {
            setAifCategoryOptions(AifCategoryOptions.map((category) =>
                category.id === parseInt(id) ? { ...category, isChecked: checked } : category
            ));
        }
    });

    const selectedLength = AifCategoryOptions?.filter(option => option.isChecked)?.length ?? 0;

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {AifCategories.slice(0, 2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedLength > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedLength}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-2">
                        <MultiSelectEntity
                            handleEntityChange={handleAifCategoryChange}
                            primaryEntity={AifCategoryOptions}
                        />
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default AifCategoryFilter;
